import { useEffect, useState } from 'react';
import invariant from 'tiny-invariant';
import { usePortalContext } from './portal-provider';
import { useActualRef } from '../hooks';
export function usePortal(props) {
  const {
    children,
    disabled = false,
    root = null,
    onMount
  } = props;
  const onMountRef = useActualRef(onMount);
  const portalContext = usePortalContext();
  const [mountRoot, setMountRoot] = useState(null);
  useEffect(() => {
    if (!disabled) {
      var _root$current, _contextRoot$current;
      const contextRoot = portalContext.root;
      const currentRoot = (_root$current = root == null ? void 0 : root.current) != null ? _root$current : null;
      const currentContextRoot = (_contextRoot$current = contextRoot == null ? void 0 : contextRoot.current) != null ? _contextRoot$current : null;
      invariant(!(contextRoot === null && currentRoot === null), `Before using Portal, you need to specify a root, where the component should be mounted or put the component under <ThemeProvider />`);
      setMountRoot(currentRoot != null ? currentRoot : currentContextRoot);
    }
  }, [root, portalContext.root, disabled]);
  useEffect(() => {
    if (disabled || mountRoot) {
      onMountRef.current == null ? void 0 : onMountRef.current();
    }
  }, [disabled, mountRoot, onMountRef]);
  return {
    disabled,
    children,
    mountRoot
  };
}